export default function isInformation(status) {
    return status === 'information';
}
